import { ResourceItem } from "../ResourceItem";
import {
  apiField,
  nestedItemArrayApiField,
  constructFromApiData,
  getApiPostData,
} from "../ResourceItemMetadata";
import { createFullClassResource } from "../../fullResource";

export enum ZastosowanieCategoryAttributeType {
  string = "string",
  integer = "integer",
  decimal = "decimal",
  singleChoice = "singleChoice",
  multipleChoice = "multipleChoice",
  decimalRange = "decimalRange",
}

export class ZastosowanieCategoryAttribute extends ResourceItem {
  @apiField()
  key!: string;
  @apiField()
  label!: string;
  @apiField()
  index: number = 0;

  @apiField()
  type!: ZastosowanieCategoryAttributeType;
  @apiField()
  unit!: string | null;
  @apiField()
  choices!: string[] | null;

  constructor(data?: any) {
    super(data);

    if (data) {
      constructFromApiData(this, data);
    }
  }

  getPostData() {
    return { id: this.id, ...getApiPostData(this) };
  }
}

export class ZastosowanieCategory extends ResourceItem {
  @apiField()
  name!: string;

  @nestedItemArrayApiField(ZastosowanieCategoryAttribute)
  attributes: ZastosowanieCategoryAttribute[] = [];

  constructor(data?: any) {
    super(data);

    if (data) {
      constructFromApiData(this, data);
    }
  }

  getPostData() {
    return getApiPostData(this);
  }
}

const apiUrl = "plm/zastosowanieCategory/";

export const zastosowanieCategoryResource = createFullClassResource(
  apiUrl,
  ZastosowanieCategory,
);
